import Popover from './src/popover';

export default Popover;


// WEBPACK FOOTER //
// ./src/components/popover/index.js